// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__Z98Ge","detailsBorder":"styles_detailsBorder__3IS8F"};